import React, { useEffect, useState } from "react";
import style from "./NoDataFound.module.css";
import { IoFolderOpenOutline } from "react-icons/io5";

const NoDataFound = () => {
  const [animate, setAnimate] = useState(false);

  // Trigger animation on mount
  useEffect(() => {
    setAnimate(true);
  }, []);

  return (
    <div className={`${style.noDataContainer} ${animate ? style.animate : ""}`}>
      <IoFolderOpenOutline className={style.noDataIcon} />
      <p className={style.noDataText}>No data found</p>
    </div>
  );
};

export default NoDataFound;